import React, { createContext, useContext, useState, ReactNode } from 'react';
import Toast from './Toast.tsx';

type ToastType = 'info' | 'success' | 'warning' | 'error';

interface ToastContextProps {
  showToast: (message: string, type?: ToastType, duration?: number) => void;
}

const ToastContext = createContext<ToastContextProps>({
  showToast: () => {},
});

export const useToast = () => useContext(ToastContext);

interface ToastProviderProps {
  children: ReactNode;
}

export const ToastProvider: React.FC<ToastProviderProps> = ({ children }) => {
  const [toast, setToast] = useState({
    message: '',
    type: 'info' as ToastType,
    show: false,
    duration: 3000,
  });

  const showToast = (message: string, type: ToastType = 'info', duration = 3000) => {
    setToast({ message, type, show: true, duration });
  };

  const handleCloseToast = () => {
    setToast((prev) => ({ ...prev, show: false }));
  };

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <Toast
        message={toast.message}
        type={toast.type}
        show={toast.show}
        duration={toast.duration}
        onClose={handleCloseToast}
      />
    </ToastContext.Provider>
  );
};

export default ToastContext;
